export { default } from "./AdvancedImageConfig";
